import { useEffect, useState } from "react";
import styles from "./badge.module.css";
import { BadgeProps } from "./types";

const Badge = ({ team, isPresentation, isAlternative }: BadgeProps) => {
  const code = team.code || 0;
  const [prefersDark, setPrefersDark] = useState(false);

  // Check for dark theme on the root of the app.
  // We can't just use mediaMatch as games without dark mode support are hard coded to light theme
  useEffect(() => {
    const root = document.querySelector(".ism[data-theme]");
    if (!root) return;

    const updateTheme = () =>
      setPrefersDark(root.getAttribute("data-theme") === "dark");

    updateTheme();
    const observer = new MutationObserver(updateTheme);
    observer.observe(root, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  if (!code) {
    return null;
  }

  const badgeDir = isAlternative || prefersDark ? "badges-alt" : "badges";
  const path = `${
    import.meta.env.VITE_PULSE_STATIC_BASE
  }/${badgeDir}/${code}.svg`;

  return (
    <img
      className={styles.badge}
      src={path}
      alt={isPresentation ? "" : team.name}
      role={isPresentation ? "presentation" : ""}
    />
  );
};

export default Badge;
